import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchProductsSummary} from "../../../../../reduxLib/productLib";
import {createCategory, deleteCategory, fetchPcategories, updateCategory} from "../../../../../reduxLib/pcategoriesLib";
import CategoryItem from "./elements/categoryItem";
import EditCategoryModal from "./elements/EditCategoryModal";
import AddCategoryModal from "./elements/AddCategoryModal";
import uploadCategoryImage from "../../../../../Utilities/uploadHelper";
import ConfirmDeleteModal from "../productAdmin/elements/confirmDeleteModal";

function CategoriesAd() {

    const dispatch = useDispatch();
    const [productSummaryPage,setProductsSummaryPage]=useState([]);
    const productSummaryL= useSelector((state)=> state.productreducer.productSymmaryListpage);
    const state=useSelector((state)=> state.productreducer.state);

    const [categories,setCategories]=useState([]);
    const categoriesL= useSelector((state)=> state.categoryreducer.pcategoriesList);
    const stateC=useSelector((state)=> state.categoryreducer.state);

    const [filteredCat,setFilteredCat]=useState([]);


    useEffect(() => {
        if (!productSummaryL || productSummaryL.length === 0 ) {

            dispatch(fetchProductsSummary()).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setProductsSummaryPage(action.payload);

                    console.log("playload ",action.payload);
                    console.log("playload E", productSummaryPage);
                }
            });

        }
        else {
            // ίδια κατηγορία -> πάρε cached
            setProductsSummaryPage(productSummaryL);
        }
    }, [dispatch, state,productSummaryL]);

    useEffect(() => {
        if (!categoriesL || categoriesL.length === 0 ) {

            dispatch(fetchPcategories()).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setCategories(action.payload);
                    setFilteredCat(
                        action.payload.filter(c => c.productsListIDs.length===0)
                    );
                    console.log("playload ",action.payload);
                    console.log("playload E", categories);
                }
            });

        }
        else {
            // ίδια κατηγορία -> πάρε cached
            setCategories(categoriesL);
            setFilteredCat(categoriesL.filter(c => c.productsListIDs.length===0));
        }
    }, [dispatch, stateC,categoriesL]);

    // --- MODAL HANDLERS ---
    const [isAddOpen, setIsAddOpen] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryToDelete, setCategoryToDelete] = useState(null);
    const openAddCategoryModal = () => setIsAddOpen(true);
    const closeAddCategoryModal = () => setIsAddOpen(false);

    const openEditCategoryModal = (cat) => {
        setSelectedCategory(cat);
        setIsEditOpen(true);
    };

    const closeEditCategoryModal = () => {
        setIsEditOpen(false);
        setSelectedCategory(null);
    };

    const openDeleteCategoryModal = (cat) => {
        setCategoryToDelete(cat);
        setIsDeleteOpen(true);
    };

    const closeDeleteCategoryModal = () => {
        setIsDeleteOpen(false);
        setCategoryToDelete(null);
    };

    useEffect(() => {
        setFilteredCat((categories || []).filter((c) => c.productsListIDs.length === 0));
    }, [categories]);

    // ✅ SUBMIT handlers που καλούνται από τα modals
    /*const handleCreateCategory = (form) => {
        console.log("CREATE", form);
        // TODO: dispatch(createCategory(form))
        // μετά μπορείς να κάνεις refetch ή να ενημερώσεις local state
    };*/
    const handleCreateCategory = async (form) => {

        let imageUrl = null;

        if (form.image) {
            imageUrl = await uploadCategoryImage(form.name, form.image);
        }

        const categoryPayload = {
            ...form,
            image: imageUrl,
        };

        console.log("CREATE", categoryPayload);

        const action = await dispatch(createCategory(categoryPayload));
        if (action.error) {
            throw new Error(action.error.message || "Create category failed");
        }
        if (action.payload) {
            setCategories((prev) => [action.payload, ...prev]);
        }

        return action.payload;
    };


    const handleUpdateCategory = async (form) => {
        const id=form?.categoryID;

        let imageUrl = form.imurlcurrent; // default στην τρέχουσα εικόνα

        //if (form.image && form.image instanceof File) {}
        if (form.image && form.image !== form.imurlcurrent) {
            //if (form.image) {
            imageUrl = await uploadCategoryImage(form.name, form.image);
        }

        const categoryPayload = {
            ...form,
            image: imageUrl,
        };

        console.log("UPDATE", id, categoryPayload);

        const action = await dispatch(updateCategory({
            categoryData: categoryPayload,
            cid: id
        }));

        if (action.error) {
            throw new Error(action.error.message || "Update category failed");
        }
        if (action.payload) {
            setCategories((prev) => prev.map((c) => c.categoryID === id ? action.payload : c));
        }

        return action.payload;
    };

    // Placeholder αν δεν το έχεις ακόμα
    /*const deleteCategory = (id) => {
        console.log("DELETE", id);
        // TODO: dispatch(deleteCategory(id))
    };*/
    const deleteCategoryAct = async (id) => {

        const action = await dispatch(deleteCategory(id));
        if (action.error) {
            throw new Error(action.error.message || "Delete category failed");
        }
        if (action.payload) {
            setCategories((prev) => prev.filter((c) => c.categoryID !== id));
        }
        closeDeleteCategoryModal();

        return action.payload;
    };



    return (
        <div id="categories-content" className="p-8 bg-cream font-script">
            <div id="category-stats" className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Total Categories</p>
                            <p className="text-2xl font-bold text-gray-800">{categories?.length}</p>
                            {/*<p className="text-green-600 text-sm mt-1">2 added this month</p>*/}
                        </div>
                        <i className="fa-solid fa-list text-3xl text-custom-green"></i>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Active Products</p>
                            <p className="text-2xl font-bold text-gray-800">{productSummaryPage?.length}</p>
                            <p className="text-blue-600 text-sm mt-1">Across all categories</p>
                        </div>
                        <i className="fa-solid fa-shopping-bag text-3xl text-custom-green"></i>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow card-hover">
                    <div className="flex items-center justify-between">
                        <div>
                            <p className="text-gray-600 text-sm">Empty Categories</p>
                            <p className="text-2xl font-bold text-gray-800">{filteredCat?.length}</p>
                            <p className="text-orange-600 text-sm mt-1">Need attention</p>
                        </div>
                        <i className="fa-solid fa-exclamation-triangle text-3xl text-orange-500"></i>
                    </div>
                </div>
            </div>

            <div id="category-actions" className="bg-white rounded-lg shadow p-6 mb-8">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">

                    <div className="flex gap-3">

                        <button onClick={openAddCategoryModal}
                                className="px-6 py-2 bg-custom-green text-white rounded-lg hover:bg-opacity-90 flex items-center gap-2 font-medium">
                            <i className="fa-solid fa-plus"></i>
                            Add Category
                        </button>
                    </div>
                </div>
            </div>

            <div id="categories-list" className="bg-white rounded-lg shadow overflow-hidden">
                <table className="w-full">
                    <thead className="bg-gray-50 border-b">
                    <tr>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Category</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Description</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Products</th>
                        {/*<th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Sales</th>
                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Status</th>*/}
                        <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">Actions</th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">

                    {
                        categories?.map((cat) => (
                            <CategoryItem key={cat.categoryID}
                                          id={cat.categoryID}
                                          name={cat.name}
                                          description={cat.description}
                                          image={cat.image}
                                          productsListIDs={cat.productsListIDs}
                                          onEdit={() => openEditCategoryModal(cat)}
                                          onDelete={() => openDeleteCategoryModal(cat)}
                            />
                        ))
                    }
                    </tbody>
                </table>
            </div>
            <AddCategoryModal
                isOpen={isAddOpen}
                onClose={closeAddCategoryModal}
                onSubmit={handleCreateCategory}
            />

            <EditCategoryModal
                isOpen={isEditOpen}
                onClose={closeEditCategoryModal}
                category={selectedCategory}
                onSubmit={handleUpdateCategory}
            />

            <ConfirmDeleteModal
                open={isDeleteOpen}
                setOpen={setIsDeleteOpen}
                title="Delete Category"
                message={categoryToDelete ? `Are you sure you want to delete \"${categoryToDelete.name}\"?` : "Are you sure you want to delete this category?"}
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={() => categoryToDelete && deleteCategoryAct(categoryToDelete.categoryID)}
            />
        </div>
    );

}

export default CategoriesAd;